/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Link } from 'react-router-dom'

/**
 *     Import
 *     - Images
 */
import { EditIcon } from '../../../../images/icons/Edit/Edit'
import { RenewalBindIcon } from '../../../../images/icons/Renewal/RenewalBindIcon'
import { ViewIcon } from '../../../../images/icons/View/View'

/**
 * Each Policies row from the ClientsTable component
 *
 * @export
 * @class ClientsRowQuotes
 * @extends {React.Component<any, any>}
 */
export default class ClientsRowRenewalQuotes extends React.Component<any, any> {
    render() {
        const { quote: { id = '', renewalForPolicyId = '' } } = this.props
        return (
            <div className={`table__row`}>
                <div className="column">{this.props.quote.clientName}</div>
                <div className="column">{this.props.quote.inceptionDate}</div>
                <div className="column">{this.props.quote.quotedDate}</div>
                <div className="column">{this.props.quote.daysValid} days</div>
                <div className="column renewal_quote_center">
                    <div>
                        <Link to={`/clients/quotes/view/${id}`}>
                            <ViewIcon />
                        </Link>
                    </div>
                    <div>
                        <Link to={`/renewals/edit/${renewalForPolicyId}`}>
                            <EditIcon />
                        </Link>
                    </div>
                    <div>
                        <Link to={`/renewals/bind/${renewalForPolicyId}`}>
                            <RenewalBindIcon />
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Clients/components/ClientsRowRenewalQuotes.tsx